@if(selectedAccount?.currency === 'GBP'){
<finxone-web-frontend-add-beneficiary-ukfp></finxone-web-frontend-add-beneficiary-ukfp>
}@else if(selectedAccount?.currency === 'EUR'){
<finxone-web-frontend-add-beneficiary-sepa></finxone-web-frontend-add-beneficiary-sepa>
}@else{
<span>Your selected account is missing or the currency is not supported. Please contact support.</span>
}
